import { Dispatch } from 'react';
import { EVENTS_NEW_REQUEST } from '../../../constants/events';

import {
    ADD_NOTIFICATION,
    MODAL_CLOSED,
    REMOVE_NOTIFICATION,
    SHOW_CERTIFIED_FILE_MODAL,
    TOGGLE_NEW_REQUEST_MODAL,
    CONFIRM_LEAVE_MODAL_CLOSED,
    HIDE_TRIAL_BAR,
    HIDE_FIXED_NOTIFICATIONS_WRAPPER,
    getEventDataAction,
    addNotificationAction,
    removeNotificationAction,
    modalClosedAction,
    toggleNewRequestModalAction,
    confirmLeaveModalClosedAction,
    hideTrialBarAction,
    showCertifiedFileModalAction,
    hideFixedNotificationWraperAction,
    dashboardNewRequestModalAction,
    SET_DASHBOARD_NEW_REQUEST_MODAL,
} from '../types';

export const getEventData = (): ((dispatch: Dispatch<getEventDataAction>) => void) => {
    return (dispatch: Dispatch<getEventDataAction>) => {
        dispatch({
            type: EVENTS_NEW_REQUEST,
            payload: '',
        });
    };
};

export const addNotification = (payload: any): ((dispatch: Dispatch<addNotificationAction>) => void) => {
    return (dispatch: Dispatch<addNotificationAction>) => {
        dispatch({
            type: ADD_NOTIFICATION,
            payload,
        });
    };
};

export const removeNotification = (): ((dispatch: Dispatch<removeNotificationAction>) => void) => {
    return (dispatch: Dispatch<removeNotificationAction>) => {
        dispatch({
            type: REMOVE_NOTIFICATION,
        });
    };
};

export const modalClosed = (payload: any): ((dispatch: Dispatch<modalClosedAction>) => void) => {
    return (dispatch: Dispatch<modalClosedAction>) => {
        dispatch({
            type: MODAL_CLOSED,
            payload,
        });
    };
};

export const toggleNewRequestModal = (status: boolean): ((dispatch: Dispatch<toggleNewRequestModalAction>) => void) => {
    const payload = { status };
    return (dispatch: Dispatch<toggleNewRequestModalAction>) => {
        dispatch({
            type: TOGGLE_NEW_REQUEST_MODAL,
            payload,
        });
    };
};

export const confirmModalClosed = (payload: any): ((dispatch: Dispatch<confirmLeaveModalClosedAction>) => void) => {
    return (dispatch: Dispatch<confirmLeaveModalClosedAction>) => {
        dispatch({
            type: CONFIRM_LEAVE_MODAL_CLOSED,
            payload,
        });
    };
};

export const hideTrialBarEvent = (hideTrialBar: boolean): ((dispatch: Dispatch<hideTrialBarAction>) => void) => {
    const payload = { hideTrialBar };
    return (dispatch: Dispatch<hideTrialBarAction>) => {
        dispatch({
            type: HIDE_TRIAL_BAR,
            payload,
        });
    };
};

export const setShowCertifiedModal = (
    payload: boolean
): ((dispatch: Dispatch<showCertifiedFileModalAction>) => void) => {
    return (dispatch: Dispatch<showCertifiedFileModalAction>) => {
        dispatch({
            type: SHOW_CERTIFIED_FILE_MODAL,
            payload,
        });
    };
};

export const hideFixedNotificationsWrapper = (
    hideFixedNotificationsWrapper: boolean
): ((dispatch: Dispatch<hideFixedNotificationWraperAction>) => void) => {
    const payload = { hideFixedNotificationsWrapper };

    return (dispatch: Dispatch<hideFixedNotificationWraperAction>) => {
        dispatch({
            type: HIDE_FIXED_NOTIFICATIONS_WRAPPER,
            payload,
        });
    };
};

export const setDashboardNewRequestModal = (
    payload: dashboardNewRequestModalAction['payload']
): ((dispatch: Dispatch<dashboardNewRequestModalAction>) => void) => {
    return (dispatch: Dispatch<dashboardNewRequestModalAction>) => {
        dispatch({
            type: SET_DASHBOARD_NEW_REQUEST_MODAL,
            payload,
        });
    };
};
